import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore';
import { axiosInterceptor } from './authComponents/globalAxios';
import BackdropLoading from "./components/CM/cm_shared/SpinnerScreen"
import { LoadingProvider } from '../src/context/spinnerContext'
//file:index.js
//import necessary dependencies
//function:configureStore

const store = configureStore();
axiosInterceptor(store)
const jsx = (
    <LoadingProvider>
    <Provider store={store}>
        <BackdropLoading />
        <App />
    </Provider>
    </LoadingProvider>
)


ReactDOM.render(jsx, document.getElementById('root'));
registerServiceWorker();
